module.exports = __webpack_public_path__ + "img/boat001.47843af6.jpg";